export default "__VITE_ASSET__CzE1WMRF__"